import {
  Link,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Avatar,
  Typography,
  useTheme,
  Divider,
  Button,
  useMediaQuery,
} from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resizeImage } from '../../api/cloudinary';
import { track } from '../../api/track';
import { RankedUser } from '../leaderboards';

type PropTypes = {
  rankings?: RankedUser[];
};

export const Rankings = ({ rankings }: PropTypes) => {
  const navigate = useNavigate();

  const theme = useTheme();
  const xsBreakpoint = useMediaQuery(theme.breakpoints.only('xs'));

  const handleUsernameClick = async (e: any, player: RankedUser) => {
    e.stopPropagation();
    await track(player.profileId, 'rankings.username.link', player.username);
    navigate(`/profile/overview/${player.profileId}`);
  };

  const rankingData = (rankings: RankedUser[]) =>
    xsBreakpoint ? rankings?.slice(0, 20) : rankings?.slice(0, 10);

  return (
    <>
      <Stack direction="row">
        <TableContainer component={Paper} sx={{ maxHeight: 432 }}>
          <Table stickyHeader size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell width={'8%'} sx={{ textAlign: 'center' }}>
                  Rank
                </TableCell>
                <TableCell width={'50%'}>Player</TableCell>
                <TableCell
                  width={'15%'}
                  sx={{
                    color: theme.palette.ranked.main,
                    fontWeight: 600,
                    textAlign: 'center',
                  }}
                >
                  MMR
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rankingData(rankings)?.map((row: any, index: any) => (
                <TableRow key={row.profileId}>
                  <TableCell sx={{ textAlign: 'center' }}>
                    {index + 1}
                  </TableCell>
                  <TableCell>
                    <Stack direction={'row'} spacing={2}>
                      <Avatar
                        src={resizeImage(row.avatarPublicId, 50, 50)}
                        variant="rounded"
                        sx={{
                          height: 25,
                          width: 25,
                        }}
                      >
                        {!row.avatarUrl ? row.username.charAt(0) : null}
                      </Avatar>
                      <Link
                        component="button"
                        variant="body2"
                        onClick={(e) => handleUsernameClick(e, row)}
                        textAlign={'left'}
                      >
                        <Typography
                          sx={{
                            lineHeight: '25px',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            width: '150px',
                          }}
                        >
                          {' '}
                          {row.username}
                        </Typography>
                      </Link>
                    </Stack>
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      color: theme.palette.ranked.main,
                      fontWeight: 600,
                    }}
                  >
                    {row.rankedRating ? Math.floor(row.rankedRating) : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!xsBreakpoint ? (
          <>
            <Divider orientation="vertical" flexItem />
            <TableContainer component={Paper}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell width={'8%'} sx={{ textAlign: 'center' }}>
                      Rank
                    </TableCell>
                    <TableCell width={'50%'}>Player</TableCell>
                    <TableCell
                      width={'15%'}
                      sx={{
                        color: theme.palette.ranked.main,
                        fontWeight: 600,
                        textAlign: 'center',
                      }}
                    >
                      MMR
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rankings?.slice(10, 20).map((row: any, index: any) => (
                    <TableRow key={row.profileId}>
                      <TableCell sx={{ textAlign: 'center' }}>
                        {index + 11}
                      </TableCell>
                      <TableCell>
                        <Stack direction={'row'} spacing={2}>
                          <Avatar
                            src={resizeImage(row.avatarPublicId, 50, 50)}
                            variant="rounded"
                            sx={{
                              height: 25,
                              width: 25,
                            }}
                          >
                            {!row.avatarUrl ? row.username.charAt(0) : null}
                          </Avatar>
                          <Link
                            component="button"
                            variant="body2"
                            onClick={(e) => handleUsernameClick(e, row)}
                            textAlign={'left'}
                          >
                            <Typography
                              sx={{
                                lineHeight: '25px',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                width: '150px',
                              }}
                            >
                              {' '}
                              {row.username}
                            </Typography>
                          </Link>
                        </Stack>
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          color: theme.palette.ranked.main,
                          fontWeight: 600,
                        }}
                      >
                        {row.rankedRating ? Math.floor(row.rankedRating) : ''}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : null}
      </Stack>
    </>
  );
};
